import { createWorkerAction } from '../lib';
export var fitIntoView = createWorkerAction('FIT_INTO_VIEW');
